import { render, staticRenderFns } from "./DashboardQuotationNumberDisplayer.vue?vue&type=template&id=2d13e127"
import script from "./DashboardQuotationNumberDisplayer.vue?vue&type=script&lang=ts"
export * from "./DashboardQuotationNumberDisplayer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports